export const fetchPromise = (url, options) => {
  return new Promise((resolve, reject) => {
    fetch(url, { ...options, credentials: 'same-origin' })
      .then((response) => response.text())
      .then((text) => (text ? JSON.parse(text) : null))
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
